import ProductListResultModelBase from '../_generated/modelBases/product-list-result-model-base';

export default class ProductListResultModel extends ProductListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
